import { format, isSameDay, parseISO, subMinutes } from 'date-fns';
import { Booking } from '../models/entities/booking';
import { Room } from '../models/entities/room';

export class BookingTooltipHelper {
  static tooltipOf(
    booking: Booking,
    room: Room,
    translate: (key: string) => string,
    title: string = booking.company ?? booking.name,
  ): string {
    const lines = [
      `<strong>${this.escapeHtml(title)}</strong>`,
      this.escapeHtml(room.full_name),
      this.periodOf(booking),
      ...this.characteristicsOf(booking, translate),
    ];
    return lines.join('<br>');
  }

  private static characteristicsOf(
    booking: Booking,
    translate: (key: string) => string,
  ): string[] {
    const characteristics = [];
    if (booking.recurrence_rule) {
      characteristics.push(
        `<i class="far fa-repeat"></i> ${translate('bookings.calendar-block.recurring-booking')}`,
      );
    }
    return characteristics;
  }

  private static periodOf(booking: Booking): string {
    const start = parseISO(booking.start);
    const end = parseISO(booking.end);
    if (isSameDay(start, subMinutes(end, 1))) {
      return `${format(start, 'dd.MM.yyyy')}, ${format(start, 'HH:mm')} - ${format(end, 'kk:mm')}`;
    }
    return `${format(start, 'dd.MM.yyyy HH:mm')} - ${format(end, 'dd.MM.yyyy HH:mm')}`;
  }

  private static escapeHtml(text: string): string {
    return (text ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}
